<template>
    <div class="view"  v-if="hasPermissions(['Associate Write'])">
        <Breadcrumb :breadcrumb="breadcrumb"/>

        <h1 class="view__title title--1" v-html="title_page"/>

        <div class="row ml-0">
            <h6 class="view__title title--1" style="font-size: 13px; font-weight: initial; color: gray;">
                <span>
                    <img src="/assets/img/svg/information.svg" style="width:15px;" alt="info">
                </span>
                <span v-html="'Use this section to search for associates.'" style="margin-left:5px;"/>
            </h6>
        </div>
        <AssociatesAdvancedSearch
            ref="advanced_search"
            :checkeable="true"
            :rest_api="rest_api"
            :rest_api_pagination="rest_api_pagination"
            @passInitialData="getInitialData($event)"
        />
        <hr/>
        <div class="row mb-0 ml-0">
            <div style="font-size: 13px; font-weight: initial; color: gray; margin-top: 30px;">
                <span>
                    <img src="/assets/img/svg/information.svg" style="width:15px;" alt="info">
                </span>
                <span v-html="'Use this section to make changes.'" style="margin-left:5px;"/>
            </div>
        </div>
        <form @submit.prevent="form_submit()">
            <FormDynamic
                :form_format="form_format"
                :form_data="form_data"
                :array_options="array_options"
                :for_update="false"
                :content_align_x="'no-justify'"
            />
            <div class="row mb-0 assignments">
                <div class="col-md-12">
                    <div class="text-md-left mt-lg-3">
                        <CentralLiteButtons
                            :not_show_cancel="true"
                            :type="''"
                            :save_text="'Save changes'"
                        />
                    </div>
                </div>
            </div>
        </form>
        <FieldsConfirmationModal 
            :title="'Fields massive confirmation'"
            :breadcrumb="breadcrumb"
            :form_data="form_data"
            :notyf="notyf" 
            @formSubmit="form_submit(true)"
            ref="fields_confirmation_modal"
        />
        <Summary 
            :breadcrumb="breadcrumb"
            :validate_data="summary"
        />
        <HelperModal :helps="helps"/>
        <WaitingModal/>
    </div>

</template>
<script>

import Methods from './methods'
import { Notyf } from 'notyf'
import Resources from './resources'
import FormResources from './form_resources'
import Summary from './Summary'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import CentralLiteButtons       from    '@/components/CentralLiteButtons'
import HelperModal          from    '@/components/HelperModal'
import WaitingModal from '@/components/WaitingModal'
import AssociatesAdvancedSearch  from '../AdvancedSearch/AssociatesAdvancedSearch'
import FieldsConfirmationModal from  './FieldsConfirmationModal'
import FormDynamic      from    '@/components/FormDynamic.vue'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
})

export default 
{
    name: 'MassEditAssociates',
    components:{
        Breadcrumb,
        WaitingModal,
        AssociatesAdvancedSearch,
        FormDynamic,
        CentralLiteButtons,
        FieldsConfirmationModal,
        Summary,
        HelperModal
    },

    mixins:[
        Methods,
    ],

    data(){
        return{
            notyf,
            title_page:         'Associates - Mass Edit Associates',
            rest_api:           `associates`,
            rest_api_pagination: `associates_pagination`,
            child_href:         '/building-room/',
            table_headers:      Resources.table_headers,
            breadcrumb:         Resources.breadcrumb,
            form_format:        FormResources.form_format,
            form_data:          FormResources.form_data,
            form_backup:        {...FormResources.form_data},
            select_all:         false,
            rooms:              [],
            array_options:      {},
            search:             '',
            summary: [],
            helps:                Resources.helps
        }
    },

}
    
</script>